import { UserGraphQLResponse } from './graphQL/user-graphQL.response';
import { MiUsuarioGraphQLResponse } from './graphQL/miUsuario-graphQL.response';

export class User {
    uuid: string;
    user: string;
    name: string;
    state: string;
    email: string;
    firstName: string;
    timeZone: string;
    language: string;
    rol?: string[];
    dispositivos?: any;
    factories?: any;

    constructor(response: MiUsuarioGraphQLResponse) {
        this.uuid = response.miUsuario.uuid;
        this.user = response.miUsuario.usuario;
        this.name = response.miUsuario.nombre;
        this.firstName = response.miUsuario.apellidos;
        this.state = response.miUsuario.enabled;
        this.timeZone = response.miUsuario.zonaHoraria;
        this.language = response.miUsuario.idioma;
        this.rol = response.miUsuario.rol;
        this.dispositivos = response.miUsuario.dispositivos;
        this.factories = response.miUsuario.dispositivos;
        this.email = response.miUsuario.mail;
    }
}
